import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import GroupModel from 'js/models/group.model';
import Template from 'js/templates/group.hbs';
import InnerView from 'js/views/subscribers.list.view';
import PromosView from 'js/views/promos.view';
import {el, tagName, template} from "../adapters/backbone-decorators";

require('metroHelpers');

@el("#single-group-container")
@tagName('span')
@template(Template)
class GroupView extends GenericView {
    constructor(options) {
        super(options);
        this.options = options;
        this.model = new GroupModel({id: this.id});
        this.loadGroup();
    }

    render() {
        super.render();
        const collectionUrl = `/CampaignCloud/Config/Group/${this.model.get(this.model.idAttribute)}/WithFilters`;
        this.promosView = new PromosView({
            el: "#messages-container",
            collectionUrl: collectionUrl,
            narrow: true,
            url: `/CampaignCloud/Report/countOfTotalSmsEmailForGroup/${this.model.get(this.model.idAttribute)}`,
            groupMsg: true
        });
        this.innerView = new InnerView({groupModel: this.model});
        this.innerView.load({postpaid: this.options.postpaid, groupId: this.id});
        this.$('[data-i18n]').i18n();
    }

    updateCallback(attributeName, value, outcome, e, settings) {
        if ("OK" === outcome) {
            const newHtml = "true" === value.toString() ? "true" : "";
            $(e).find('.hidden').html(newHtml);
            $(e).toggleClass('busy', !value);
            $(e).toggleClass('available', value);
        }
        return super.updateCallback(attributeName, value, outcome, e, settings);
    }

    async loadGroup() {
        try {
            await this.model.fetch();
        } catch (error) {
            console.error(error.statusText);
            $.Notify.error(i18n.t("groups.retrievingerrorstatus"));
        } finally {
            this.render();
        }
    }
}

export default GroupView;
